import script from "./ConfirmarV2.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmarV2.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmarV2.vue?vue&type=style&index=0&id=041d6f2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041d6f2c"]])

export default __exports__